import React from 'react';
import { Button } from "@/components/ui/button";
import { Bell } from "lucide-react";
import { 
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { API_ENDPOINTS } from "../../../constants/config";

const SendFeeNotification = ({ students, onSendNotification }) => {
  const handleSendNotification = async () => {
    try {
      const response = await fetch(API_ENDPOINTS.feesSendNotifications, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ studentIds: students.map(s => s._id) })
      });

      if (!response.ok) throw new Error('Failed to send notifications');

      if (onSendNotification) onSendNotification();
    } catch (error) {
      console.error("Failed to send fee reminders", error);
    }
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button 
          variant="outline" 
          className="flex items-center gap-2"
          disabled={!students?.length}
        >
          <Bell className="h-4 w-4" />
          Send Fee Reminders ({students?.length || 0} students)
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Send Fee Reminders</AlertDialogTitle>
          <AlertDialogDescription>
            This will send fee payment reminders to {students?.length} students with pending fees.
            Students will receive notifications about their pending fees and due dates.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleSendNotification}>
            Send Reminders
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default SendFeeNotification;